import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import MarkHandover from './MarkHandover';
import { getChannelPartnerListing, transferHandoverAgainstChannelPartner } from 'services/redux/sales/channelPartner/action';

const mapStateToProps = (state) => ({
  channelPartnerListing: state.channelPartnerReducer.channelPartnerListing,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getChannelPartnerListing,
      transferHandoverAgainstChannelPartner
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(MarkHandover);